(() => {
  const sticky = document.getElementById("MBStickyATC");
  if (!sticky) return;

  const btn = document.getElementById("MBStickyATCButton");
  const selectionEl = document.getElementById("MBStickyATCSelection");
  const changeBtn = document.getElementById("MBStickyATCChange");
  if (!btn) return;

  const productForm =
    document.querySelector('form[action*="/cart/add"]') ||
    document.querySelector("product-form form");

  const FORCE_REDIRECT_TO_CART = false;

  const getVariantIdFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    const v = params.get("variant");
    return v ? String(v) : null;
  };

  const getVariantIdFromForm = () => {
    if (!productForm) return null;
    const input = productForm.querySelector('input[name="id"]');
    return input && input.value ? String(input.value) : null;
  };

  let productJson = null;
  const jsonEl = document.querySelector('[id^="MBProductJSON-"]');
  if (jsonEl) {
    try {
      productJson = JSON.parse(jsonEl.textContent);
    } catch (e) {
      productJson = null;
    }
  }

  const getDefaultVariantIdFromJson = () => {
    if (!productJson || !Array.isArray(productJson.variants)) return null;

    const firstAvailable = productJson.variants.find((v) => v && v.available);
    if (firstAvailable && firstAvailable.id) return String(firstAvailable.id);

    const first = productJson.variants[0];
    return first && first.id ? String(first.id) : null;
  };

  const getCurrentVariantId = () => {
    return getVariantIdFromUrl() || getVariantIdFromForm() || getDefaultVariantIdFromJson();
  };

  const getCurrentVariantObj = () => {
    const vid = getCurrentVariantId();
    if (!vid || !productJson || !productJson.variants) return null;
    return productJson.variants.find((x) => String(x.id) === String(vid)) || null;
  };

  const isCurrentVariantAvailable = () => {
    const v = getCurrentVariantObj();
    if (!v) return true;
    return !!v.available;
  };

  const getSelectedOptionsText = () => {
    const v = getCurrentVariantObj();
    if (!v) return "";
    return [v.option1, v.option2, v.option3].filter(Boolean).join(" • ");
  };

  const updateButtonState = () => {
    const vid = getCurrentVariantId();
    const selectionText = getSelectedOptionsText();

    if (selectionEl) {
      selectionEl.textContent = selectionText ? `Selected: ${selectionText}` : "";
    }

    if (!vid) {
      btn.disabled = true;
      btn.textContent = "Add to cart";
      return;
    }

    if (!isCurrentVariantAvailable()) {
      btn.disabled = true;
      btn.textContent = "Sold out";
      return;
    }

    btn.disabled = false;
    btn.textContent = "Add to cart";
  };

  const addToCart = async (variantId) => {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    });

    if (!res.ok) {
      let msg = "Unable to add to cart";
      try {
        const err = await res.json();
        if (err && err.description) msg = err.description;
      } catch (e) {}
      throw new Error(msg);
    }

    return res.json();
  };

  const getCart = async () => {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error("Unable to fetch cart");
    return res.json();
  };

  const findDrawer = () => {
    return (
      document.querySelector("cart-drawer") ||
      document.getElementById("CartDrawer") ||
      document.querySelector("[data-cart-drawer]") ||
      document.querySelector(".cart-drawer") ||
      document.querySelector(".drawer") ||
      document.querySelector(".drawer__inner")
    );
  };

  const openDrawerBestEffort = () => {
    const drawer = findDrawer();
    if (!drawer) return false;

    drawer.setAttribute("open", "true");
    drawer.classList.add("is-open", "active", "open");

    document.documentElement.classList.add("cart-drawer-open");
    document.body.classList.add("cart-drawer-open");

    return true;
  };

  const refreshThemeCart = async () => {
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    document.dispatchEvent(new CustomEvent("cart:updated"));
    document.dispatchEvent(new CustomEvent("theme:cart:refresh"));
    document.dispatchEvent(new CustomEvent("ajaxProduct:added"));

    try {
      const cart = await getCart();
      document.dispatchEvent(new CustomEvent("mb:cart", { detail: cart }));
    } catch (e) {}

    return openDrawerBestEffort();
  };

  // Sticky visibility trigger
  const mainAtcBtn =
    (productForm && productForm.querySelector('[type="submit"]')) ||
    document.querySelector('button[name="add"]') ||
    document.querySelector('button[type="submit"][name="add"]');

  const setStickyVisible = (visible) => {
    sticky.setAttribute("aria-hidden", visible ? "false" : "true");
    sticky.classList.toggle("is-visible", visible);
  };

  const onScroll = () => {
    if (!mainAtcBtn) {
      setStickyVisible((window.scrollY || 0) > 250);
      return;
    }
    const r = mainAtcBtn.getBoundingClientRect();
    const threshold = 80;
    const atcNearLeaving = r.bottom <= (window.innerHeight - threshold);
    setStickyVisible(atcNearLeaving);
  };

  const hookHistory = () => {
    const _push = history.pushState;
    const _replace = history.replaceState;
    const fire = () => window.dispatchEvent(new Event("mb:variantchange"));

    history.pushState = function () {
      _push.apply(this, arguments);
      fire();
    };

    history.replaceState = function () {
      _replace.apply(this, arguments);
      fire();
    };

    window.addEventListener("popstate", fire);
  };

  hookHistory();

  if (productForm) {
    productForm.addEventListener("change", () => setTimeout(updateButtonState, 0));
    productForm.addEventListener("click", () => setTimeout(updateButtonState, 0));
  }

  window.addEventListener("mb:variantchange", () => setTimeout(updateButtonState, 0));

  // Find option blocks to scroll to
  const findSizeTarget = () => {
    return (
      document.querySelector('fieldset[name="Size"]') ||
      document.querySelector('[data-option-name*="Size"]')
    );
  };

  const findColorTarget = () => {
    const candidates = [
      document.querySelector('#MBColorSiblings'),
      document.querySelector('[data-mb-color-siblings]'),
      document.querySelector('.mb-color-siblings'),
      document.querySelector('[class*="color"][class*="sibling"]'),
      document.querySelector('fieldset[name="Color"]'),
      document.querySelector('[data-option-name*="Color"]'),
    ].filter(Boolean);

    return candidates[0] || null;
  };

  const getDynamicTopOffset = () => {
    // Account for sticky headers/announcement bars on desktop
    const selectors = [
      ".announcement-bar",
      ".announcement",
      ".header-wrapper",
      ".site-header",
      "header",
    ];

    let h = 0;
    selectors.forEach((sel) => {
      const el = document.querySelector(sel);
      if (!el) return;

      const cs = window.getComputedStyle(el);
      const pos = cs.position;

      // Only count fixed/sticky things that sit at the top
      if (pos === "fixed" || pos === "sticky") {
        const r = el.getBoundingClientRect();
        if (r.height > 0 && r.top <= 5) h += r.height;
      }
    });

    // Add breathing room so the option row is comfortably visible
    return Math.min(Math.max(h + 24, 120), 220);
  };

  const smoothScrollTo = (targetEl) => {
    if (!targetEl) return;

    const rect = targetEl.getBoundingClientRect();
    const currentY = window.scrollY || window.pageYOffset;

    const offset = getDynamicTopOffset();
    const targetY = Math.max(0, currentY + rect.top - offset);

    window.scrollTo({ top: targetY, behavior: "smooth" });

    // Safety: if the target is still partially clipped after scroll (rare), nudge once
    setTimeout(() => {
      const r2 = targetEl.getBoundingClientRect();
      const offset2 = getDynamicTopOffset();
      if (r2.top < offset2 || r2.top > offset2 + 40) {
        const y2 = (window.scrollY || window.pageYOffset) + r2.top - offset2;
        window.scrollTo({ top: Math.max(0, y2), behavior: "smooth" });
      }
    }, 220);
  };

  const onEditOptions = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    if (e && e.preventDefault && e.cancelable) e.preventDefault();

    const sizeTarget = findSizeTarget();
    const colorTarget = findColorTarget();

    // Prefer size (apparel), otherwise color siblings (accessories), otherwise product form
    const target = sizeTarget || colorTarget || productForm || mainAtcBtn;
    smoothScrollTo(target);
  };

  if (changeBtn) {
    changeBtn.addEventListener("click", onEditOptions);
    changeBtn.addEventListener("pointerup", onEditOptions, { passive: false });
    changeBtn.addEventListener("touchend", onEditOptions, { passive: false });
  }

  // Add to cart (click is enough on desktop, mobile already mostly fine)
  btn.addEventListener("click", async () => {
    const vid = getCurrentVariantId();
    if (!vid) return;
    if (!isCurrentVariantAvailable()) return;

    btn.disabled = true;
    btn.textContent = "Adding...";

    try {
      await addToCart(vid);

      if (FORCE_REDIRECT_TO_CART) {
        window.location.href = "/cart";
        return;
      }

      const drawerOpened = await refreshThemeCart();
      btn.textContent = drawerOpened ? "Added" : "Added to cart";

      setTimeout(() => {
        updateButtonState();
      }, 700);
    } catch (err) {
      alert((err && err.message) || "Unable to add to cart");
      updateButtonState();
    }
  });

  // Init
  updateButtonState();
  onScroll();

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);

  setTimeout(updateButtonState, 120);
  setTimeout(updateButtonState, 500);
})();